// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZVfR","delete":"styles_delete__3-b6I","update":"styles_update__2fge-","add":"styles_add__3p4Vi"};